import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import TitleBar from "../containers/Layout/TitleBar";
import LeftBar from "../containers/Layout/LeftBar";
import { AppContext, DispatchContext } from "../AppContext";
import { Route, Switch } from "react-router-dom";
import DashboardComponent from "../containers/DashboardComponent";
import HomeComponent from "../containers/Home";
import ReportOverViewComponent from "../containers/ReportOverview/ReportOverview";
import ReportReviewComponent from "../containers/ReportReview/ReportReview";
import NewPlagiarismCheckComponent from "../containers/NewPlagiarismCheck/NewPlagiarismCheck";
import NewLibraryText from "../containers/NewLibraryText/NewLibraryText";
import ToolComponent from "../containers/Tool";
import ProjectComponent from "../containers/Project";
import LicenseComponent from "../containers/LicenseComponent";
import TestMonitoringComponent from "../containers/TestMonitoring";
import Service from "../services/service";
import * as actions from "../actions/actions";
import ConfirmationDialog from "../components/ConfirmationDialog";
import LogDialog from "../components/LogDialog";
import ResetPlagiarismCheckComponent from "../containers/ResetPlagiarismCheck";
import ReactTooltip from "react-tooltip";
import LibraryOverviewComponent from "../containers/LibraryOverview/LibraryOverview";
import DownloadReportDialog from "../components/DownloadReportDialog";
import ProfileDialog from "../components/ProfileDialog";
import PasteDialog from "../components/PasteDialog";
import { hideCaptcha } from '../helpers/constants';


const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    flex: "0 0 auto",
    flexDirection: "column",
  },
  paMain: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "row",
  },
  paCenter: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    background: theme.palette.background.image,
    backgroundSize: 'cover',
  },
  paAppBar: {
    zIndex: 10,
  },
  paBottomBar: {
    height: 40,
  },
  paCenterHeader: {
    display: "flex",
    height: '50px',
    backgroundColor: "#eeeeee",
    alignItems: "center",
    margin: "0",
    padding: '0px 15px',
    zIndex: 5,
    boxShadow: "0px 0px 0px 2px rgba(0, 0, 0, 0.2)",
  },
  paCenterHeaderIcon: {
    marginLeft: 'auto',
    textAlign: 'end',
    width: 100
  },
  icon_block: {
    "font-size": "18px",
    "margin": "0 5px"
  },
  title_head: {
    paddingLeft: "15px",
    display: "contents",
    fontSize: "18px",
  },
  cursor_pointer: {
    cursor: 'pointer'
  },
  tooltip: {
    zIndex: 5000,
    position: "absolute",
    fontSize: "12px",
    maxWidth: "500px !important",
    wordWrap: "break-word"
    //overflow: 'hidden',
    //textOverflow: 'ellipsis',
    //whiteSpace: 'nowrap',
  }
}));

export default function AppGrid(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const classes = useStyles(state);


  useEffect(() => {
    if (!state.user.loggedIn) {
      return;
    }

    hideCaptcha();

    Service.getProjects().then(res => {
      if (res.success) {
        dispatch(actions.get_projects(res.data || []))
        dispatch(actions.set_chosen_projects([{ Id: 0, Name: '[Unassigned library texts]' }, ...res.data] || []));

        let filteredData;
        if (res.data && res.data.length > 1 && state.projectFilter.search) {
          filteredData = res.data.filter((item) => (item.Name.toLowerCase()).indexOf(state.projectFilter.search.toLowerCase()) > -1)
        } else {
          filteredData = res.data;
        }
        if (filteredData && filteredData.length > 1 && state.projectPagination) {
          if (state.projectPagination.sortby === 'PlagChecks' || state.projectPagination.sortby === 'LibraryTexts') {
            filteredData.slice().sort((a, b) => {
              return (+a[state.projectPagination.sortby] - +b[state.projectPagination.sortby]);
            });
          } else {
            filteredData.slice().sort((a, b) => {
              return ('' + a[state.projectPagination.sortby]).localeCompare(b[state.projectPagination.sortby]);
            });
          }
        }
        dispatch(actions.get_projects_filter(filteredData || []));
        dispatch(actions.change_project_pagination(state.projectPagination));
        if (state.selectedProject) {
          let rowDetails = filteredData.filter(i => i.Id === state.selectedProject.Id)[0];
          if (rowDetails) {
            dispatch(actions.changeProjectSelection(rowDetails));
          } else {
            dispatch(actions.changeProjectSelection({}));
          }
        }
      }
    });
  }, [state.projectsChangeNo]);

  useEffect(() => {
    ReactTooltip.rebuild();
  });
  



  if (!state.user.loggedIn) {
    dispatch(actions.navigate_to("/login"));
    return null;
  }

  return (
    <>
      <DownloadReportDialog />
      <ConfirmationDialog />
      <PasteDialog />
      <LogDialog />
      <ProfileDialog />

      <ReactTooltip id="globalTT" effect="solid" place="top" delayShow={500} className={classes.tooltip} disable={!state.user.settings.showTooltips} />
      <ReactTooltip id="compareTT" place="top" className={classes.tooltip}/>
      <ReactTooltip id="sourceTT" html={true} place="top" className={classes.tooltip} />

      <div className={classes.root}>
        <div className={classes.paAppBar}>
          <TitleBar />
        </div>
        <div className={classes.paMain}>
          <LeftBar />
          <div className={classes.paCenter}>
            {/* Routing Structure */}
            <Switch>
              <Route exact path="/" component={DashboardComponent} />
              <Route path="/checkout" component={DashboardComponent} />
              <Route exact path="/dashboard" component={DashboardComponent} />
              <Route exact path="/dashboard/:module" component={DashboardComponent} />
              <Route exact path="/dashboard/:module/:productId" component={DashboardComponent} />
              <Route path="/home" component={HomeComponent} />
              <Route path="/plagiarism/new" component={NewPlagiarismCheckComponent} />
              <Route path="/plagiarism/reports/:id" component={ReportReviewComponent} />
              <Route path="/plagiarism/reports" component={ReportOverViewComponent} />
              <Route path="/testmonitoring" component={TestMonitoringComponent} />
              <Route path="/reset-plagiarism-check" component={ResetPlagiarismCheckComponent} />
              <Route path="/tools" component={ToolComponent} />
              <Route path="/library/new" component={NewLibraryText} />
              <Route path="/library/overview" component={LibraryOverviewComponent} />
              <Route path="/projects" component={ProjectComponent} />
              <Route path="/license" component={LicenseComponent} />
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
}
